import React, { useEffect } from 'react';
import { Button, Flex } from 'antd';
import { FilePdfOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { coreBrandColors } from '../../theming';
import { truncate } from '../../utils/truncate';
import classes from './styles.module.scss';
import { useMedia } from '../../hooks/useMediaQuery';
import { spacing } from '../../theming';
import { jobStatusNames } from '../../common/constants/jobStatusNames';

export const FileItem = ({ file, onPreview, onDelete, jobStatus }) => {
    const { t } = useTranslation(['fileActions']);
    const isDone = file.status === 'done';
    const { isExtraSmallDevice } = useMedia();

    const allowedStatusesForDeletion = [jobStatusNames.New, jobStatusNames.InProgress];

    const isDeleteButtonActive = jobStatus =>
        jobStatus && jobStatus.name && allowedStatusesForDeletion.includes(jobStatus.name);

    return (
        <div className={classes['file-item']}>
            <div className={classes['file-info']}>
                <FilePdfOutlined className={classes['file-icon']} />
                <Flex vertical={!isDone}>
                    <span className={classes['file-name']} title={file.name}>
                        {truncate(file.name, isExtraSmallDevice ? 20 : 25)}
                    </span>
                    {!isDone && <span style={{ color: 'gray' }}>({t('fileActions:notUploaded')})</span>}
                </Flex>
            </div>
            <Flex
                justify={isExtraSmallDevice ? 'space-around' : 'flex-end'}
                gap={spacing[2]}
                align="center"
                style={{ width: '100%' }}
            >
                {isDone && (
                    <Button
                        type="link"
                        size="small"
                        onClick={() => onPreview(file.name)}
                        style={{ color: coreBrandColors.blueRibbon }}
                    >
                        {t('fileActions:buttons.preview')}
                    </Button>
                )}
                <Button
                    disabled={!isDeleteButtonActive(jobStatus)}
                    type="link"
                    size="small"
                    danger
                    onClick={() => (isDone ? onDelete(file.name) : onDelete())}
                >
                    {t('fileActions:buttons.delete')}
                </Button>
            </Flex>
        </div>
    );
};
